import { HeaderCellProps } from '../types';

export const TeamLastActivityHeaderCell = ({ _customRowProps }: HeaderCellProps) => {
  return <div>Last Activity</div>;
};
